<div class="fiche-consultant-header__controls">
  @if (showBackButton()) {
    <oui-button
      class="fiche-consultant-header__controls__back-btn"
      type="icon"
      color="secondary"
      (click)="back.emit()"
      ><oui-icon>arrow_back</oui-icon></oui-button
    >
  } @else if (isExpendSideNav()) {
    <oui-button
      class="fiche-consultant-header__controls__back-btn"
      type="icon"
      color="secondary"
      title="Réduire"
      (click)="expendSideNav.emit()"
      ><oui-icon>fullscreen_exit</oui-icon></oui-button
    >
  } @else {
    <oui-button
      class="fiche-consultant-header__controls__back-btn"
      type="icon"
      color="secondary"
      title="Agrandir"
      (click)="expendSideNav.emit()"
      ><oui-icon>fullscreen</oui-icon></oui-button
    >
  }

  <oui-button
    class="fiche-consultant-header__controls__close-btn"
    type="icon"
    color="secondary"
    (click)="close.emit()"
    ><oui-icon>close</oui-icon></oui-button
  >
</div>

<oui-avatar [imageSrc]="photoUrl()"></oui-avatar>

<div class="headline-5">{{ consultant().prenom }} {{ consultant().nom }}</div>

<div class="fiche-consultant-header__informations-reseau body-2">
  <div>
    @if (consultant().isJunior) {
      Consultant junior
    } @else if (consultant().qualification) {
      {{ consultant().qualification }}
    }
  </div>
  @if (consultantResiliation()?.dateResiliation) {
    <div class="medium-emphasis resilie-container">
      @if (consultantResiliation()?.commentaire) {
        <oui-infos-bulle class="warning-icon" bulleTitle="Commentaire">{{
          consultantResiliation()?.commentaire
        }}</oui-infos-bulle>
      }
      <span class="warning-text">Résilié</span>
      le {{ consultantResiliation()?.dateResiliation | date: 'dd/MM/yyyy' }}
      @if (consultantResiliation()?.motif) {
        <span> - {{ getResiliationMotifName() }} </span>
      }
    </div>
  } @else {
    <div class="medium-emphasis">
      Affilié depuis le {{ consultant().dateAffiliation | date: 'dd/MM/yyyy' }}
    </div>
  }
</div>

@if (consultant().manager) {
  <div class="body-2">
    Consultant manager :
    @if (enableNavigation()) {
      <a class="body-2" (click)="consultantChange.emit(consultant().manager!.code!)">{{
        managerName()
      }}</a>
    } @else {
      <span>{{ managerName() }}</span>
    }
  </div>
}
